export default __webpack_public_path__ + "static/age-120278d5d669f777f6f0d4d4721adf7e.png";